import { useMemo } from 'react'
import { DateTime } from 'luxon'

import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { SubscriptionInfo } from 'features/home/types'
import { isExpiringSoon } from 'features/home/components/HomeSubscription/utils'

import { SubscriptionEndDate } from './styles'

interface HomeSubscriptionExpiryProps {
  subscriptionInfo: SubscriptionInfo
  withTime?: boolean
}

function DomainHomeSubscriptionEndDate(props: HomeSubscriptionExpiryProps) {
  const { subscriptionInfo, withTime } = props
  const hasWarning = useMemo(() => {
    return isExpiringSoon(subscriptionInfo, DateTime.now())
  }, [subscriptionInfo])

  return (
    <SubscriptionEndDate hasWarning={hasWarning}>
      <IntlFormattedDate
        withTime={withTime}
        date={new Date(subscriptionInfo.expiresAt)}
      />
    </SubscriptionEndDate>
  )
}

export default DomainHomeSubscriptionEndDate
